import PageDependencies from "../PageDependencies";
const DropDragDataTableInput = (props) => {
    const {useState, useEffect, useRef} = PageDependencies();
    const [value, setValue ]= useState(0);
    const bindingMethod = props.bindingMethod;
    const bindingValue = props.bindingValue;
    const cloumnName = props.cloumnName;
    const processThickness = props.processThickness;
    const eRef = useRef();

    useEffect(()=>{
      const timer = setTimeout(()=>{
           if(value !== bindingValue){
             const e = eRef.current;
               if(e !== undefined && e.target !== undefined && e.target.value !== undefined){
                    bindingMethod(e, cloumnName, processThickness);
               }
          }        
          }, 750);
          return () => {
               clearTimeout(timer);
               };
    },[value]);

     useEffect(()=>{
          if(bindingValue !== value){
               setValue(bindingValue);
          }
    },[bindingValue]);

    return( <input 
            style={{ background: "transparent", border: "none"}}
            type="number"
            id={props.id}
            ref = {props.ref}
            disabled = {props.disabled}
            value={value}
            onChange={(e)=> {
                 eRef.current = e;
                 let value = e.target.value       
                 setValue(value);
            }}
            maxLength='4'
          ></input>);
}
export default DropDragDataTableInput;